






























import {mixins} from "vue-class-component";
import {CommonMixin} from "@/shared/services/mixin";
import {Component, Watch} from "vue-property-decorator";
import {ProvinceParams} from "../../params";
import {CommonStatus} from "@/enums/status";
import EnumSelector from "@/shared/components/EnumSelector/index.vue";
import {debounce} from "lodash";
import {ProvinceStore} from "@/modules/regionsv2/province/store";
import ProvinceForm from "@/modules/regionsv2/province/Form/index.vue";
import CountrySelectorV2 from "@/modules/regionsv2/CountrySelectorV2/index.vue";
import {RoleDeclare} from "@/enums/roledeclare";

@Component({
    name: 'ProvinceSearch',
    components: {CountrySelectorV2, ProvinceForm, EnumSelector}
})
export default class extends mixins(CommonMixin) {
    params = new ProvinceParams();
    CommonStatus = CommonStatus;
    visibleForm = false;

    @Watch("params", { immediate: true, deep: true })
    onChangeParams(val) {
        this.handleChangeParams(val);
    }

    handleChangeParams = debounce((val) => {
        ProvinceStore.paramsChangeProvinceV21({ ...val, page: 1 });
    }, 300)

    create() {
        if (!this.hasPermission(RoleDeclare.ROLE_CAN_CREATE_REGION)) {
            this.$notification.error({
                message: "Từ chối truy cập",
                description: "Bạn không có quyền truy cập"
            })
            return;
        }
        this.visibleForm = true;
    }
}
